import React, { FC } from 'react'
import { Constants } from 'common/utils'
import Link from 'next/link' // we need this to make JSX compile
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
} from 'next-share'
import { generateSrcSet } from 'project/image-proxy-web'

type SocialLinksType = {
  isLight?: boolean
  urlToShare?: string
  shareTitle?: string
  linkType: 'social' | 'share'
}

const SocialLinks: FC<SocialLinksType> = ({
  isLight,
  linkType,
  shareTitle: _shareTitle,
  urlToShare: _urlToShare,
}) => {
  const shareTitle =
    _shareTitle || (typeof document !== 'undefined' ? document.title : '')
  const urlToShare = _urlToShare
    ? _urlToShare
    : typeof window !== 'undefined'
    ? window.location.href
    : ''

  const { facebook, linkedin, twitter } = Constants.companyInformation
  const SocialProfile = ({}) => {
    return (
      <>
        <li>
          <Link className='a-unstyled' href={facebook}>
            <img
              {...generateSrcSet(
                isLight
                  ? '/images/icons/homepage-fb-footer-icon-desktop-white.svg'
                  : '/images/icons/homepage-fb-footer-icon-desktop.svg',
                17,
                35,
              )}
              loading='lazy'
              className='img-fluid cursor-pointer'
              width={17}
              height={35}
              alt={'Facebook Icon'}
            />
          </Link>
        </li>
        <li>
          <Link className='a-unstyled' href={twitter}>
            <img
              {...generateSrcSet(
                isLight
                  ? '/images/icons/homepage-twitter-footer-icon-desktop-white.svg'
                  : '/images/icons/homepage-twitter-footer-icon-desktop.svg',
                36,
                35,
              )}
              loading='lazy'
              className='img-fluid cursor-pointer'
              width={36}
              height={35}
              alt={'X Icon'}
            />
          </Link>
        </li>
        <li>
          <Link className='a-unstyled' href={linkedin}>
            <img
              {...generateSrcSet(
                isLight
                  ? '/images/icons/homepage-linkedin-footer-icon-desktop-white.svg'
                  : '/images/icons/homepage-linkedin-footer-icon-desktop.svg',
                36,
                35,
              )}
              loading='lazy'
              className='img-fluid cursor-pointer'
              width={36}
              height={35}
              alt={'LinkedIn Icon'}
            />
          </Link>
        </li>
      </>
    )
  }

  const ShareLinks = ({}) => {
    return (
      <>
        <li>
          <FacebookShareButton
            style={{ width: 24 }}
            url={urlToShare}
            quote={shareTitle}
            hashtag={'#hoxtonmix'}
          >
            <img
              {...generateSrcSet(
                isLight
                  ? '/images/icons/homepage-fb-footer-icon-desktop-white.svg'
                  : '/images/icons/homepage-fb-footer-icon-desktop.svg',
                16,
                35,
              )}
              loading='eager'
              className='img-fluid cursor-pointer'
              width={16}
              height={35}
              alt={'Facebook Icon'}
            />
          </FacebookShareButton>
        </li>
        <li>
          <TwitterShareButton
            style={{ width: 24 }}
            url={urlToShare}
            title={shareTitle}
          >
            <img
              {...generateSrcSet(
                isLight
                  ? '/images/icons/homepage-twitter-footer-icon-desktop-white.svg'
                  : '/images/icons/homepage-twitter-footer-icon-desktop.svg',
                36,
                35,
              )}
              loading='eager'
              className='img-fluid cursor-pointer'
              width={35}
              height={35}
              alt={'X Icon'}
            />
          </TwitterShareButton>
        </li>
        <li>
          <LinkedinShareButton
            style={{ width: 24 }}
            url={urlToShare}
            title={shareTitle}
          >
            <img
              {...generateSrcSet(
                isLight
                  ? '/images/icons/homepage-linkedin-footer-icon-desktop-white.svg'
                  : '/images/icons/homepage-linkedin-footer-icon-desktop.svg',
                36,
                35,
              )}
              loading='eager'
              className='img-fluid cursor-pointer'
              width={35}
              height={35}
              alt={'LinkedIn Icon'}
            />
          </LinkedinShareButton>
        </li>
      </>
    )
  }

  return (
    <ul className='list-unstyled d-flex mt-4 mb-lg-0 mb-8 mb-0 social-icons '>
      {linkType === 'share' ? <ShareLinks /> : <SocialProfile />}
    </ul>
  )
}

export default SocialLinks
